import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84f6db14"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-form-welcome-text-wrapper" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Willkommen"),
  /*#__PURE__*/_createElementVNode("h3", null, "Anmeldung"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Melden Sie sich mit Ihrer Kundennummer und Ihrem persönlichen Passwort an. Sollten Sie Ihr Passwort vergessen haben oder auf andere Probleme stoßen, wenden Sie sich bitte "),
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:redken@de.loreal.com" }, "direkt an uns.")
  ])
], -1))
const _hoisted_2 = { class: "p-fluid grid" }
const _hoisted_3 = {
  class: "col-12",
  style: {"padding-bottom":"0px"}
}
const _hoisted_4 = { class: "" }
const _hoisted_5 = {
  class: "col-12",
  style: {"padding-bottom":"0px","padding-top":"0px"}
}
const _hoisted_6 = { class: "p-fluid grid" }
const _hoisted_7 = { class: "field col-6 flex" }
const _hoisted_8 = {
  for: "remember-me",
  class: "ml-1"
}
const _hoisted_9 = { class: "field col-12" }
const _hoisted_10 = {
  class: "form-group control-group",
  style: {"margin-top":"20px"}
}
const _hoisted_11 = {
  class: "controls col-sm-offset-4 col-sm-8",
  style: {"color":"white !important"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_validation = _resolveComponent("validation")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_GuestLayout = _resolveComponent("GuestLayout")!

  return (_openBlock(), _createBlock(_component_GuestLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
      }, [
        _hoisted_1,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_validation, {
                validations: _ctx.v$.username,
                "show-errors": true
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_InputText, {
                      placeholder: _ctx.$t('user.username'),
                      modelValue: _ctx.username,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                      id: "username",
                      type: "text",
                      style: {"padding":"14px 24px","font-size":"16px","margin-bottom":"15px","border-radius":"26px"}
                    }, null, 8, ["placeholder", "modelValue"])
                  ])
                ]),
                _: 1
              }, 8, ["validations"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_validation, {
                validations: _ctx.v$.password,
                "show-errors": true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    placeholder: _ctx.$t('auth.password'),
                    id: "password",
                    modelValue: _ctx.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                    type: "password",
                    style: {"padding":"14px 24px","font-size":"16px","margin-bottom":"15px","border-radius":"26px"}
                  }, null, 8, ["placeholder", "modelValue"])
                ]),
                _: 1
              }, 8, ["validations"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Checkbox, {
              id: "remember-me",
              name: _ctx.$t('auth.remember'),
              modelValue: _ctx.rememberMe,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rememberMe) = $event)),
              binary: true
            }, null, 8, ["name", "modelValue"]),
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("auth.remember")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Button, {
            type: "submit",
            id: "_submit",
            name: "_submit",
            class: "btn-mis--filled-white cm-btn cm-btn--lg btn-signin",
            style: {"color":"black","width":"100%","padding":"14px 24px","font-size":"16px","margin-bottom":"15px","border-radius":"26px"},
            label: _ctx.$t('auth.login'),
            loading: _ctx.isLoading
          }, null, 8, ["label", "loading"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createTextVNode(" Sie haben Ihr Passwort vergessen? "),
            _hoisted_12,
            _createTextVNode(" Dann fordern Sie "),
            _createElementVNode("a", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToResetPass && _ctx.goToResetPass(...args))),
              style: {"color":"white !important"},
              class: "lnk btn-lost-password bsh-link-arrow bsh-link-black",
              to: "{ name: 'ResetPasswordRequest' }"
            }, _toDisplayString(_ctx.$t("auth.password_forgot")) + "? ", 1)
          ])
        ])
      ], 32)
    ]),
    _: 1
  }))
}